import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_2 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full" }
const _hoisted_4 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-2 text-center" }
const _hoisted_6 = { class: "mt-5 sm:mt-6" }

import {ref} from 'vue';
import QrcodeVue from 'qrcode.vue'
import {QrCodeIcon} from '@heroicons/vue/24/outline';

import {Dialog, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'QrCode',
  props: {
    url: String,
    title: String
},
  setup(__props) {

// @ts-ignore
const props = __props

const isOpen = ref(false);

const openConfirmation = async () => {
  isOpen.value = true;
}

const closeConfirmation = async () => {
  isOpen.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs",
      "aria-label": "Toggle QR Code",
      type: "button",
      onClick: openConfirmation
    }, [
      _createVNode(_unref(QrCodeIcon), { class: "w-5 h-5 text-lg" })
    ]),
    _createVNode(_unref(TransitionRoot), {
      show: isOpen.value,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10",
          onClose: closeConfirmation
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" }, null, -1)
              ])),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-lg sm:w-full sm:p-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_unref(QrCodeIcon), { class: "w-5 h-5 text-lg" })
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(QrcodeVue, {
                                style: {"margin":"auto"},
                                value: __props.url,
                                size: 300,
                                level: "H"
                              }, null, 8, ["value"]),
                              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mt-5 text-sm text-clay-800" }, " Scan this QR code with your phone ", -1))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("button", {
                            "aria-label": "Close",
                            onClick: _withModifiers(closeConfirmation, ["prevent"]),
                            type: "button",
                            class: "inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-clay-600 border border-transparent rounded-md shadow-sm hover:bg-clay-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-500 sm:text-sm"
                          }, " Close ")
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})